import React, { Component } from "react";
import { Container } from "react-bootstrap";

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Container fluid>{this.props.children}</Container>;
  }
}

export default AppContainer;
